<template>
  <div>
    <div class="bg-white p-4">
      <div class="row mb-4">
        <div class="col-12 header">
          <div style="display: flex">
            <span class="header-icon">
              <i class="fas fa-address-book" />
            </span>
            <h2>
              {{
                $t('menu.settings.accountData.consumptionDetailsShootingAnswer')
              }}
            </h2>
          </div>
          <button
            v-b-modal.consumption-notification-modal
            class="btn btn-outline-primary"
          >
            <i class="fas fa-bell" />
            {{ $t('menu.settings.accountData.notification.button') }}
          </button>

          <b-modal
            id="consumption-notification-modal"
            :title="$t('menu.settings.accountData.notification.modalTitle')"
            size="md"
            :ok-title="$t('genericMessages.save')"
            :cancel-title="$t('genericMessages.cancel')"
            @show="getNotificationInfo"
            @ok="saveNotificationInfo"
          >
            <div class="row">
              <div class="col-12">
                <p>
                  {{
                    $t(
                      'menu.settings.accountData.notification.modalDescription',
                    )
                  }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label class="idx-bold"> </label>
                  <input
                    type="text"
                    id="consumption-notification-eamil"
                    class="form-control"
                    :placeholder="
                      $t('menu.settings.accountData.notification.inputEmail')
                    "
                    v-model="notificationEmail"
                  />
                </div>
              </div>
            </div>
            <div class="row custom-switch">
              <div class="col-12">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="switch-notification-email"
                  v-model="notificationEnabled"
                />
                <label
                  class="custom-control-label"
                  for="switch-notification-email"
                >
                  {{
                    $t(
                      'menu.settings.accountData.notification.enableNotification',
                    )
                  }}
                </label>
              </div>
            </div>
          </b-modal>
        </div>
      </div>

      <dashboard-bar refreshButton consumption />

      <div>
        <div>
          <div class="summary">
            <div class="item">
              <header>
                <h2>Volume contratado e-mail</h2>
              </header>
              <div class="description">
                <span>{{ this.planEmail }}</span>
              </div>
            </div>

            <div class="item">
              <header>
                <h2>Volume contratado SMS</h2>
              </header>
              <div class="description">
                <span style="color: #28a745">{{ this.planSms }}</span>
              </div>
            </div>

            <div class="item">
              <header>
                <h2>Saldo atual e-mail</h2>
              </header>
              <div class="description">
                <span style="color: #dc3545">{{
                  this.currentBalanceEmail
                }}</span>
              </div>
            </div>

            <div class="item">
              <header>
                <h2>Saldo atual SMS</h2>
              </header>
              <div class="description">
                <span style="color: #ffc107">{{ this.currentBalanceSms }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-5">
        <h2>{{ $t('menu.settings.accountData.channelDetailing') }}</h2>
        <b-table
          striped
          :items="consumptionByChannel"
          :fields="channelFields"
          :busy="loading"
        >
          <template v-slot:cell(conversionRate)="row">
            {{ row.item.conversionRate ? row.item.conversionRate : '-' }}
          </template>
          <template v-slot:table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner type="grow" class="align-middle"></b-spinner>
            </div>
          </template>
        </b-table>
      </div>

      <div class="mt-5">
        <h2>{{ $t('menu.settings.accountData.actionDetailing') }}</h2>
        <b-table
          striped
          :items="consumptionByAction"
          :fields="actionFields"
          :busy="loading"
        >
          <template v-slot:table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner type="grow" class="align-middle"></b-spinner>
            </div>
          </template>
        </b-table>
        <div class="pagination-area-consumtion-details mt-1 align-itens">
          <paginate
            v-model="page"
            :clickHandler="getConsumptionByAction"
            :pageCount="Math.ceil(totalActions / 5)"
            :prevText="'‹'"
            :nextText="'›'"
            :activeClass="'active'"
            :containerClass="'pagination b-pagination mt-2'"
            :pageClass="'page-item'"
          ></paginate>

          <template v-if="loadingXLS">
            <b-spinner
              variant="primary"
              type="grow"
              :label="`${this.$t('reports.loadingLabel')}...`"
            ></b-spinner>
          </template>
          <span v-else class="xls">
            <i class="fas fa-file-excel" @click="exportXls('xlsx')"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Paginate from 'vuejs-paginate';
import swal from 'sweetalert';
import dashboardBar from '@/components/molecules/dashboard-bar';
import api from '../../../services/api';

export default {
  components: {
    Paginate,
    dashboardBar,
  },

  data: () => ({
    userAuth: null,
    loading: true,
    page: 1,
    totalActions: 0,
    currentBalanceSms: 0,
    currentBalanceEmail: 0,
    planSms: 0,
    planEmail: 0,
    consumptionByChannel: [],
    consumptionByAction: [],
    notificationEmail: null,
    notificationEnabled: false,
    channelFields: [],
    actionFields: [],
    loadingXLS: false,
  }),

  computed: {
    ...mapState('actions', ['myActionId', 'myActionsIds', 'actionGroupData']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['company', 'myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
    ...mapState('branches', [
      'myIh1',
      'myIh2',
      'ih1',
      'ih2',
      'myHierarchies1',
      'myHierarchies2',
    ]),
  },

  watch: {
    myActionId: function watchmyActionId() {
      this.getAllData();
    },

    myActionsIds: function watchmyActionsIds() {
      this.getAllData();
    },

    calendarDates: function watchCalendarDates() {
      this.getAllData();
    },
  },

  methods: {
    ...mapActions('companies', ['getCompany']),

    async exportXls(type) {
      this.loadingXLS = true;

      this.apiServerlessDownloads = process.env.API_SERVERLESS_DOWNLOADS;

      try {
        await api.get(
          `${this.apiServerlessDownloads}/download/consumption/${this.userAuth.companyId}/${type}`,
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
            params: {
              actionId:
                this.myActionsIds.length === 0
                  ? null
                  : JSON.stringify(this.myActionsIds),
              startDate: this.calendarDates.start,
              endDate: this.calendarDates.end,
              groupId: this.actionGroupData._id,
            },
          },
        );

        swal({
          title: this.$t('resend.messages.export.title'),
          text: this.$t('resend.messages.export.description'),
          icon: 'success',
        });
      } catch (error) {
        swal({
          title: this.$t('resend.messages.export.errorTitle'),
          text: error.response.data.message,
          icon: 'error',
        });
      }

      this.loadingXLS = false;
    },

    async getConsumptionCurrentBalance() {
      const response = await api.get(
        `details/consumption/${this.userAuth.companyId}`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );

      this.currentBalanceEmail = response.data.consumption.currentBalanceEmail;
      this.currentBalanceSms = response.data.consumption.currentBalanceSms;

      this.planEmail = response.data.consumption.plan.qtyEmail;
      this.planSms = response.data.consumption.plan.qtySms;
    },

    async getConsumptionByChannel() {
      const response = await api.get(
        `consumption/channels/${this.userAuth.companyId}`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            actionId:
              this.myActionsIds.length === 0
                ? null
                : this.myActionsIds.join(','),
            startDate: this.calendarDates.start,
            endDate: this.calendarDates.end,
          },
        },
      );

      this.consumptionByChannel = response.data.consumption;
    },

    async getConsumptionByAction() {
      this.loading = true;
      const response = await api.get(
        `consumption/actions/${this.userAuth.companyId}`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            page: this.page,
            actionId:
              this.myActionsIds.length === 0
                ? null
                : this.myActionsIds.join(','),
            startDate: this.calendarDates.start,
            endDate: this.calendarDates.end,
          },
        },
      );

      this.consumptionByAction = response.data.consumption;
      this.totalActions = response.data.total;
      this.loading = false;
    },

    async getAllData() {
      this.loading = true;

      this.page = 1;
      this.totalActions = 0;

      await Promise.all([
        this.getConsumptionByChannel(),
        this.getConsumptionByAction(),
        this.getConsumptionCurrentBalance(),
      ]);

      this.loading = false;
    },

    async saveNotificationInfo() {
      try {
        await api.put(
          `/company/${this.userAuth.companyId}`,
          {
            notificationEmail: this.notificationEmail,
            notificationEnabled: this.notificationEnabled,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        swal({
          title: this.$t('genericMessages.success.title'),
          text: this.$t('genericMessages.success.description'),
          icon: 'success',
        });

        await this.getCompany({
          id: this.userAuth.companyId,
          token: this.userAuth.token,
        });
      } catch (error) {
        window.console.log(error);

        swal({
          title: this.$t('genericMessages.error.title'),
          text: this.$t('genericMessages.error.title.description'),
          icon: 'error',
        });
      }
    },

    getNotificationInfo() {
      this.notificationEmail = this.company.notificationEmail;
      this.notificationEnabled = this.company.notificationEnabled;
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.channelFields = [
      {
        key: 'type',
        label: this.$t('menu.settings.accountData.labels.collectionChannel'),
        class: 'text-center',
      },
      {
        key: 'submit',
        label: this.$t('menu.settings.accountData.labels.shoot'),
        class: 'text-center',
      },
      {
        key: 'reminder',
        label: this.$t('menu.settings.accountData.labels.reminder'),
        class: 'text-center',
      },
      {
        key: 'resend',
        label: this.$t('menu.settings.accountData.labels.resend'),
        class: 'text-center',
      },
      {
        key: 'reply',
        label: this.$t('menu.settings.accountData.labels.replica'),
        class: 'text-center',
      },
      {
        key: 'total',
        label: this.$t('menu.settings.accountData.labels.totalShoots'),
        class: 'text-center',
      },
      {
        key: 'answers',
        label: this.$t('menu.settings.accountData.labels.answers'),
        class: 'text-center',
      },
      {
        key: 'conversionRate',
        label: this.$t('menu.settings.accountData.labels.conversion'),
        class: 'text-center',
      },
    ];

    this.actionFields = [
      {
        key: 'name',
        label: this.$t('menu.settings.accountData.labels.action'),
        class: 'text-center',
      },
      {
        key: 'email_qty',
        label: this.$t('menu.settings.accountData.email'),
        class: 'text-center',
      },
      {
        key: 'sms_qty',
        label: this.$t('menu.settings.accountData.labels.sms'),
        class: 'text-center',
      },
      {
        key: 'wpp_qty',
        label: this.$t('menu.settings.accountData.labels.wpp'),
        class: 'text-center',
      },
      {
        key: 'total_submissions',
        label: this.$t('menu.settings.accountData.labels.totalShoots'),
        class: 'text-center',
      },
      {
        key: 'total_answers',
        label: this.$t('menu.settings.accountData.labels.answers'),
        class: 'text-center',
      },
    ];
  },

  async mounted() {
    await this.getAllData();
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
@import '@/themes/default/placeholders.scss';
.align-itens {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
}

h2 {
  text-transform: uppercase;
  font-size: 21px;
  font-weight: 100;
  color: $gray;
}

.header-icon {
  margin: 4px 8px 0 0;
  font-size: 12px;
  color: $gray;
}

.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.flag-status {
  padding: 0.2rem;
  font-size: 0.8rem;
  border-radius: 0.25rem;
  color: $white;
  width: 100px;
  text-align: center;
  opacity: 0.9;
}

.flag-status-concluido {
  background-color: #28a745;
}

.flag-status-processando {
  background-color: #ffc107;
}

.download-icon {
  padding: 5px 30px;
  background: $gray;
  color: $white;
  border-radius: 10px;
  font-size: 15px;
}

.download-icon:hover {
  cursor: pointer;
}

.pagination-area-consumtion-details >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.summary {
  display: flex;
  flex-direction: row;
  margin-left: 5px;

  .item {
    display: flex;
    flex-direction: column;
    padding: 5px 8px;
    margin-right: 10px;
    min-height: 85px;
    max-height: 85px;
    min-width: 180px;
    max-width: 180px;
    margin-top: 20px;
    -webkit-box-shadow: 0px 0px 9px -6px #000000;
    box-shadow: 0px 0px 9px -6px #000000;
    transition: 0.3s;

    &:hover {
      -webkit-box-shadow: 0px 0px 12px -6px #000000;
      box-shadow: 0px 0px 12px -6px #000000;
    }

    header {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-transform: uppercase;

      h2 {
        font-size: 11px;
      }
    }

    .description {
      display: flex;
      flex-direction: column;
      flex: 1;
      justify-content: center;
      align-items: center;

      span {
        font-size: 22px;
        font-weight: lighter;

        & + span {
          margin-top: -3px;
          font-size: 12px;
        }
      }
    }

    &:last-of-type {
      margin-right: 30px;
    }
  }
}
</style>

<style>
.pagination-area-consumtion-details .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-consumtion-details a {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/consumption-details/index.vue